import { createRoute, redirect } from '@tanstack/react-router';
import { authRoute, queryClient } from '@/App.tsx';
import { auth } from '@/lib/firebase.ts';
import { getMeQueryOptions } from '@/features/dashboard/_root/hooks/useMe.ts';
import WorkspacesPage from '@/features/auth/workspaces/pages/WorkspacesPage.tsx';
import { MyAccessDto } from '@/features/dashboard/_root/types/MyAccessDto.ts';
import WorkspacesSkeleton from '@/features/auth/workspaces/components/WorkspacesSkeleton.tsx';

export const workspacesRoute = createRoute({
  getParentRoute: () => authRoute,
  path: '/workspaces',
  component: WorkspacesPage,
  pendingComponent: WorkspacesSkeleton,
  beforeLoad: async () => {
    await auth.authStateReady();
    const user = auth.currentUser;
    if (!user) throw redirect({ to: '/auth/login' });
    if (!user.emailVerified) throw redirect({ to: '/auth/email-verification' });
    let me: MyAccessDto;
    try {
      me = await queryClient.ensureQueryData(getMeQueryOptions(user));
    } catch {
      // Błąd pokaże strona swoim LoadError, a nie ogólny ekran błędu routera.
      return;
    }
    // Bez firm i bez zaproszeń nie ma czego wybierać — jedyna droga to założenie firmy.
    if (me.accesses.length === 0 && me.invitations.length === 0) {
      throw redirect({ to: '/auth/complete-profile' });
    }
  },
});
